import React, { Component } from 'react';
import "../../css/admin/ModalFirmas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose, faTimesCircle, faCheckCircle,faToggleOff } from '@fortawesome/free-solid-svg-icons';
import logo from "../../assets/logo_espol_interno.svg";
import Face from '@material-ui/icons/Face'
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { memo } from 'react';
import { ComponenteSpinner } from './ComponenteSpinner';

export class ModalFirmas extends Component {


    render() {
        return (
            <div className="modalFirmas-background">
                <div className="modalFirmas-container">
                    <div className="modalFirmas-header1">
                        <img className='modalFirmas-logo' src={logo} alt="Logo espol" ></img>
                        <button className="modalFirmas-close" onClick={this.props.cerrarModal} >
                            <FontAwesomeIcon icon={faWindowClose}></FontAwesomeIcon>
                        </button>
                        <p className="modalFirmas-tituloHeader">{this.props.tituloHeader}</p>
                    </div>
                    <div className="modalFirmas-body">
                        {this.props.children}
                                            <div className="modalFirmas-container-btn">
                        
                        <button
                            className={this.props.estado ? "modalSolicitudes1-botones-disabled" : "modalSolicitudes1-botones"}
                            onClick={this.props.submit}
                            disabled={this.props.estado}
                        >
                            <FontAwesomeIcon icon={faCheckCircle} className='modalSolicitudes-icono-bnt'></FontAwesomeIcon>
                            {this.props.txtBtnSubmit}
                        </button>
                        { this.props.loading_spinner_btn &&
                            <ComponenteSpinner></ComponenteSpinner>
                        }
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default memo(ModalFirmas);
